import React, { useState } from 'react';

import './Program.user.item.scss';
import { PatientAvatar as UserAvatar } from '../../visuals/Patient.avatar';
import ItemMenu from '../../forms/menu/MenuComponent';
import {useNavigate} from 'react-router-dom';
import { Subject } from 'rxjs';
import {getDateFormat} from "../../utils/date";
import Checkbox from "../../forms/inputs/Checkboxk";
import {useTranslation} from "react-i18next";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";

const ROLE_OPTIONS = [
    { label: 'Administrator', value: 'admin' },
    { label: 'Clinician', value: 'clinician' },
    { label: 'Staff', value: 'staff' },
    { label: 'Read only', value: 'read' },
    { label: 'Command only', value: 'command-only' }
];

function ProgramUserItem({ currentUser, currentOrg, clinician, selectedUsers, hoverUser, onHover, onDeleteItem, onChange }) {
    const {t} = useTranslation(['common','teams']);
    const [closeMenuSubject] = useState(new Subject());
    const navigate = useNavigate();

    const goToViewPatient = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_USERS, {tag: 'button', event: 'onClick', action: 'click option user detail', user_id: clinician._id});
        navigate(`/users/view/${clinician._id}`);
    }
    const isChecked = () => {
        return selectedUsers.find((t) => t._id === clinician._id);
    }
    const isHover = () => {
        return hoverUser && hoverUser._id === clinician._id;
    }
    const handleClick = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_USERS, {tag: 'row', event: 'onClick', action: 'click row patient', user_id: clinician._id});
        onHover(clinician);
    }
    const roleLabel = (clinician.role && ROLE_OPTIONS.find(ro => ro.value === clinician.role)) || { label: 'Read only' };
    const phone = clinician.phones.find(ph => ph.label === 'Mobile') || clinician.phones[0];
    const getPhone = (phone) => {
        if (!phone || !phone.number) {
            return '--';
        }
        if (phone.number.search(/\+/) !== -1) {
                return phone.number;
            }
        return '+' + phone.code + ' ' + phone.number;
    }
    return (
        <div className={`__UserItem ${isHover() ? 'selected' : ''}`} onClick={handleClick}>
            <div>
                {
                    currentUser.userRoles.userPatients.edit? <Checkbox bool={isChecked()} onChange={() => onChange(clinician)}/> : ''
                }
            </div>
            <UserAvatar bio={clinician.user.bio} small={true} programId={clinician.programId} status={clinician.user.isDisabled ? 'disenrolled' : null}/>
            <div className="name">
                <h3 onClick={goToViewPatient}>
                    {clinician.user.bio.lastname}, {clinician.user.bio.firstname}
                </h3>
                {
                    clinician.isNew ?
                        <div className="_isNew">
                            {t('new')}
                    </div>
                        : ''
                }
            </div>
            <p>
                {
                    getPhone(phone)
                }
            </p>
            <p>
                {roleLabel.label}
            </p>
            <p>
                {getDateFormat(currentOrg, clinician.dateOfBirth, 'short')}
            </p>
            <div>
                {
                    currentUser.userRoles.userPatients.edit?
                        <ItemMenu actionWillRedirect={false}  forceCloseSubject={closeMenuSubject} fixed={true}
                                  label={'User Options'} event={PAGES.PROGRAM_USERS} eventParams={{user_id: clinician._id}}>
                            <>
                                <div className="_option" onClick={goToViewPatient}>
                                    <p>{t('teams:user-detail')}</p>
                                </div>
                                <div className="_option" onClick={() => onDeleteItem(clinician)}>
                                    <p>{t('teams:remove-user')}</p>
                                </div>
                            </>
                        </ItemMenu> : ''
                }
            </div>
        </div>
    )
}

export default ProgramUserItem;
